import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { LinkActionComponent } from '../../../components/link-action/link-action.component';
import { AsHtmlDirective } from '../../../../../../../../../libs/shared-components/src/lib/directives/as-html.directive';

import { SectionComponent } from '../../../../../../../../../libs/shared-components/src/lib/components/section/section.component';
import { ReitUpdatesService } from '@kolytics/shared-api';

@Component({
  selector: 'klt-overview-reit-update',
  templateUrl: './overview-reit-update.component.html',
  styleUrls: ['./overview-reit-update.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SectionComponent, AsHtmlDirective, LinkActionComponent],
})
export class OverviewReitUpdateComponent implements OnInit {
  @Input()
  public showTitleScroll = true;

  @Input()
  public showPagination = true;

  @Input()
  public itemsPerPage = 3;

  @Input() public reits: {
    title: string;
    date: string;
    description: string;
    showMore?: boolean;
  }[] = [];
  public paginateReits: {
    title: string;
    date: string;
    description: string;
    showMore?: boolean;
  }[] = [];
  public pageActive = 1;

  constructor(
    private reitUpdateService: ReitUpdatesService,
    private changeDetectorRef: ChangeDetectorRef,
    protected readonly activatedRoute: ActivatedRoute,
  ) {}

  // TODO: pageSize: 1000 should be handled differently
  public ngOnInit(): void {
    if (this.reits.length <= 0) {
      const reitId =
        this.activatedRoute.snapshot.parent?.paramMap.get('id') || null;
      const source = !!reitId
        ? this.reitUpdateService.apiReitUpdatesReitIdGet(
            Number(reitId),
            undefined,
            undefined,
            1,
            1000,
          )
        : this.reitUpdateService.apiReitUpdatesGet(1, 1000);
      source.subscribe((res) => {
        this.reits = res.data.map((item: any) => ({
          date: moment(item.publicationDate).format('DD MMM YYYY'),
          title: item.title,
          description: item.description,
        }));
        this.pagination();
      });
    } else {
      this.pagination();
    }
  }

  public pagination(): void {
    this.paginateReits = this.reits.filter(
      (e, i) =>
        i >= (this.pageActive - 1) * this.itemsPerPage &&
        i <= this.pageActive * this.itemsPerPage - 1,
    );
    this.changeDetectorRef.detectChanges();
  }
}
